import React from "react";
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import "./App.css";
function App() {
	return (
		<Router>
			<div
				style={{
					display: "flex",
					height: "100%",
					alignItems: "center",
					justifyContent: "center",
					flexDirection: "column",
				}}
			>
				<nav style={{ display: "none" }}>
					<ul>
						<li>
							<Link to="/">Home</Link>
						</li>
						<li>
							<Link to="/about">About</Link>
						</li>
					</ul>
				</nav>

				{/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
				<Switch>
					<Route path="/">
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								flexDirection: "column",
							}}
						>
							<img
								src="/assets/images/nomad-n.png"
								alt="Nomad logo"
								width={75}
							/>
							<h1 style={{ textAlign: "center" }}>Nomad App</h1>
							<h2 style={{ textAlign: "center" }}>Coming soon...</h2>
						</div>
					</Route>
					<Route path="/about">
						<h1>About Nomad</h1>
					</Route>
				</Switch>
			</div>
		</Router>
	);
}

export default App;
